import { FiCheck, FiCheckCircle, FiClock, FiLink, FiX } from "react-icons/fi";
import type { ClarificationReviewSummary } from "../../../../types/clarification-review.type";

interface ReviewProgressBarProps {
	summary: ClarificationReviewSummary;
}

export const ReviewProgressBar: React.FC<ReviewProgressBarProps> = ({ summary }) => {
	const { total, reviewed, accepted, declined, duplicate } = summary;
	const isComplete = total > 0 && reviewed === total;
	const percentage = total > 0 ? Math.round((reviewed / total) * 100) : 0;

	return (
		<div className="rounded-lg border border-gray-200 bg-white p-4" data-testid="review-progress-bar">
			<div className="flex items-center justify-between mb-2">
				<div className="flex items-center gap-2">
					{isComplete ? (
						<FiCheckCircle className="text-green-500" size={16} />
					) : (
						<FiClock className="text-amber-500" size={16} />
					)}
					<span className="text-sm font-medium text-gray-700">
						{reviewed} of {total} clarifications reviewed
					</span>
				</div>
				<span className="text-xs text-gray-500">{percentage}%</span>
			</div>

			<div className="h-2 w-full rounded-full bg-gray-100 overflow-hidden">
				<div
					className="h-full rounded-full bg-blue-500 transition-all duration-300"
					style={{ width: `${percentage}%` }}
				/>
			</div>

			{total > 0 && (
				<div className="mt-2 flex gap-4 text-xs text-gray-500">
					<span className="inline-flex items-center gap-1">
						<FiCheck className="text-green-600" size={10} />
						Accepted: {accepted}
					</span>
					<span className="inline-flex items-center gap-1">
						<FiX className="text-red-600" size={10} />
						Declined: {declined}
					</span>
					<span className="inline-flex items-center gap-1">
						<FiLink className="text-gray-500" size={10} />
						Duplicate: {duplicate}
					</span>
				</div>
			)}
		</div>
	);
};
